module.exports = __webpack_public_path__ + "static/media/peakreduction.9c6c64b7.png";